import React from 'react';
import Icon from '@ant-design/icons';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';

const WarningSvg = () => (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M78.5 40C78.5 61.263 61.263 78.5 40 78.5C18.737 78.5 1.5 61.263 1.5 40C1.5 18.737 18.737 1.5 40 1.5C61.263 1.5 78.5 18.737 78.5 40Z"
            stroke="#F7B28B"
            strokeWidth="3"
        />
        <path d="M40 56.9706L40 53" stroke="#F7B28B" strokeWidth="3" />
        <path d="M40 51L40 23.0294" stroke="#F7B28B" strokeWidth="3" />
    </svg>
);
const WarningIcon = (props: Partial<CustomIconComponentProps>) => <Icon component={WarningSvg} {...props} />;
export default WarningIcon;
